<template>
  <div :class="$style.noDataContainer">
    <div :class="$style.iconContainer"><HgIcon icon="Hourglass" :class="$style.icon" /></div>
    <span :class="$style.bodyText">{{ t('propertyDetail.noData') }}</span>
  </div>
</template>
<script lang="ts" setup>
import { HgIcon } from '@smg-real-estate/domus';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
<style lang="scss" module>
@use '@/assets/variables' as *;

.noDataContainer {
  display: flex;
  align-items: center;
  gap: $space-75;
  padding: $space-75;
  max-width: 200px;
  min-height: $space-200;
  background-color: $color-grey-30;
  border-radius: $border-radius-l;
  @include grid-media-query(sm) {
    width: 200px;
  }
}
.iconContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: $space-200;
  height: $space-200;
  border-radius: 50%;
  background-color: $color-grey-50;
}
.icon {
  color: $color-deep-blue-90;
}
.bodyText {
  @include caption;
  color: $color-deep-blue-100;
}
</style>
